/** @jsx jsx */
import { ArrowForwardIcon, Flex } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { DateIsoString } from "@/core/types";
import { useFormats } from "@/hooks/Formats";

export interface DateRangeProps {
  from: DateIsoString;
  to: DateIsoString;
}

export const DateRange: FC<DateRangeProps> = ({ from, to }) => {
  const { formatDate } = useFormats();

  return (
    <Flex gap="xxs" alignItems="center" flexWrap="wrap">
      <span>{formatDate(from)}</span>
      <ArrowForwardIcon />
      <span>{formatDate(to)}</span>
    </Flex>
  );
};
